import { Text } from '@ps-design-system/components/Text';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BillingAddressForm } from '../checkout-forms/BillingAddressForm/BillingAddressForm';

export const BillingAddressSection = () => {
  return (
    <div>
      <Text
        element="h5"
        typeface="headline-2-m"
        style={{ margin: '0px', marginBottom: '16px' }}
      >
        <FormattedMessage
          id="checkout.billing_address"
          defaultMessage="Billing address"
        />
      </Text>
      <BillingAddressForm />
    </div>
  );
};
